import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material';
import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';

 @Component({
    selector: 'test-common-dialog',
   templateUrl: 'test-common-dialog.html',
   encapsulation: ViewEncapsulation.None
  })
 export class TestCommonDialog implements OnInit {

   public title: string = "";
   public body: string = "";
 
   ngOnInit(): void {

     this.title = this.data.selectedTitle;
     this.body = this.data.selectedText;
   }

    constructor(
        public dialogRef: MatDialogRef<TestCommonDialog>,
        @Inject(MAT_DIALOG_DATA) public data: any) {}
    
      onNoClick(): void {
        this.dialogRef.close();
     }

     onSaveClose(): void {


       //close windows
       this.dialogRef.close("ok");


     }

     

  }
